import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useDataModal } from '../../hooks/useDataModal';
import { dataModalState } from '../../recoil/modal/data-modal.state';
import { channels as defaultChannels } from '../../test.data';
import { Channel } from '../../types/channel.types';
import { itemsBetween, searchForValue } from '../../utils/common.util';
import Card from '../cards/card';
import HeaderInfoCard from '../cards/v2/info-card/header.info-card';
import ChannelRow from '../containers/channel/channel-row';
import Container from '../containers/container';
import SearchInput from '../form/search-input';
import { VStack } from '../layouts/stack.layout';

const styles = {
  container: 'h-full w-full relative',
  header: 'pt-3 sticky top-0 z-50 bg-[#08080D]/50 backdrop-blur-lg',
  'avatar-wrapper': 'mask h-fit w-fit mask-squircle p-1 bg-[#121212]',
  footer: 'sticky bottom-0 h-7 z-70 bg-[#08080D]',
  body: 'mobile:px-2 tablet-lg:px-5',
  'share-input-container':
    'w-full mobile:px-2 tablet-lg:px-5 border-y border-dark-gray py-4',
};

export default function ShareModal() {
  const [, closeShareModal] = useDataModal('', 'SHARE');
  const [searchValue, setShareValue] = useState('');
  const shareModalData = useRecoilValue(dataModalState);

  //  channels you joined
  const joinedChannels = defaultChannels.filter(
    ({ hasJoined }) => hasJoined === true
  );
  // temporary since we aren't doing a query
  const results: Channel[] = itemsBetween(
    joinedChannels,
    searchForValue(
      searchValue,
      defaultChannels.map((channel: Channel) => ({
        title: channel.title || '',
        id: channel.id || '',
      }))
    )
  );
  return (
    <Card className={styles.container}>
      <Card.Header className={styles.header}>
        <VStack gap="base">
          <HeaderInfoCard
            variant="modal"
            close={closeShareModal}
            title="Share to Channel"
          />
          <Container extensions={styles['share-input-container']}>
            {/** Start transition might be helpful when we are actually querying db */}
            <SearchInput
              value={searchValue}
              set={setShareValue}
              placeholder="Search for channel"
            />
          </Container>
        </VStack>
      </Card.Header>
      <Card.Body className={styles.body}>
        <VStack gap="xs" extensions="pt-3">
          {searchValue.length === 0 &&
            joinedChannels.map(({ id, backgroundImage, title, favourite }) => (
              <>
                {id && backgroundImage && title && (
                  <ChannelRow
                    key={id}
                    channelImageUrl={backgroundImage}
                    title={title}
                    isFavorite={favourite}
                    channelId={id}
                    query={`fid=${shareModalData.id}`}
                  />
                )}
              </>
            ))}
          {searchValue.length >= 1 &&
            results.map(({ id, backgroundImage, title, favourite }) => (
              <>
                {id && backgroundImage && title && (
                  <ChannelRow
                    key={id}
                    channelImageUrl={backgroundImage}
                    title={title}
                    isFavorite={favourite}
                    channelId={id}
                    query={`fid=${shareModalData.id}`}
                  />
                )}
              </>
            ))}
        </VStack>
      </Card.Body>
      <Card.Footer className={styles.footer}>
        <div />
      </Card.Footer>
    </Card>
  );
}

// const updateSeachResults = (value: string) => {
//   const searchSpace = defaultChannels.map((channel: SpaceMinifiedType) => ({
//     title: channel.title,
//     id: channel.id,
//   }));
//   // search for results
//   const results = searchForValue(value, searchSpace);
//   // now update the channls using the id
//   setShareChannels((prev) => ({
//     data: itemsBetween(defaultChannels, results),
//   }));
// };

// useEffect(() => {
//   if (searchValue.length > 0) {
//     setSearchResults(channels);
//   } else {
//     setSearchResults(defaultChannels);
//   }
// }, [searchValue, channels]);
